import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-profile-pending',
  templateUrl: './profile-pending.component.html',
  styleUrls: ['./profile-pending.component.scss']
})
export class ProfilePendingComponent implements OnInit {

  constructor(
    private _dialogRef: MatDialogRef<ProfilePendingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: null,
  ) { }

  ngOnInit(): void {
  }
  dialogClose() {
    // this._dialogRef.close();
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }
}
